const isDev = import.meta.env.DEV

import { call, put, takeLatest } from 'redux-saga/effects'
import { navigate } from '@reach/router'

// redux
import * as shiftLogEntriesApi from '../apiModules/shiftLogEntries'
import * as shiftLogEntriesModule from '../modules/shiftLogEntries'

// utils
import { updateParamFilter } from 'utils/searchFilterHelpers'

function* fetchShiftLogEntries({ payload }) {
  try {
    const response = yield call(shiftLogEntriesApi.fetchShiftLogEntries, payload)
    yield put(shiftLogEntriesModule.fetchShiftLogEntriesSuccess(response))
  } catch (err) {
    yield put(shiftLogEntriesModule.fetchShiftLogEntriesFailure(err.response.data))
  }
}

function* fetchShiftLogEntry({ payload }) {
  try {
    const response = yield call(shiftLogEntriesApi.fetchShiftLogEntry, payload)
    const result = { ...response, forceRefresh: payload.forceRefresh }
    yield put(shiftLogEntriesModule.fetchShiftLogEntrySuccess(result))
  } catch (err) {
    yield put(shiftLogEntriesModule.fetchShiftLogEntryFailure(err.response.data))
  }
}

function* fetchSignedParticipants({ payload }) {
  try {
    const response = yield call(shiftLogEntriesApi.fetchSignedParticipants, payload)
    yield put(shiftLogEntriesModule.fetchSignedParticipantsSuccess(response))
  } catch (err) {
    yield put(shiftLogEntriesModule.fetchSignedParticipantsFailure(err.response.data))
  }
}

function* createShiftLogEntry({ payload }) {
  try {
    const formDataVals = new FormData()

    Object.keys(payload).map(value => {
      if (payload[value]) {
        formDataVals.append(value, payload[value])
      }
    })

    const response = yield call(shiftLogEntriesApi.createShiftLogEntry, formDataVals)
    yield put(shiftLogEntriesModule.createShiftLogEntrySuccess(response.data))

    updateParamFilter({ value: null, valType: 'addNewEntry' })
  } catch (err) {
    yield put(shiftLogEntriesModule.createShiftLogEntryFailure(err.response.data))
  }
}

function* updateShiftLogEntry({ payload }) {
  try {
    yield call(shiftLogEntriesApi.updateShiftLogEntry, payload)
    yield put(shiftLogEntriesModule.updateShiftLogEntrySuccess(payload))

    navigate(`${isDev ? '/timekeeper' : ''}?approvedTimeEntry=true`)
  } catch (err) {
    yield put(
      shiftLogEntriesModule.updateShiftLogEntryFailure({
        errorMessage: err.response.data.message
      })
    )
  }
}

export const shiftLogEntriesSagas = [
  takeLatest(shiftLogEntriesModule.FETCH_SHIFT_LOG_ENTRIES, fetchShiftLogEntries),
  takeLatest(shiftLogEntriesModule.FETCH_SHIFT_LOG_ENTRY, fetchShiftLogEntry),
  takeLatest(shiftLogEntriesModule.FETCH_SIGNED_PARTICIPANTS, fetchSignedParticipants),
  takeLatest(shiftLogEntriesModule.CREATE_SHIFT_LOG_ENTRY, createShiftLogEntry),
  takeLatest(shiftLogEntriesModule.UPDATE_SHIFT_LOG_ENTRY, updateShiftLogEntry)
]
